import { PaymentsMethods } from "@/api/restaurant/types/transactionsTypes";
import { COMPANY_NAME } from "@/utils/constants/defaultNames";
import { formatEnumValue } from "@/utils/formatEnumValue";

export const formatPaymentMethod = (method: string) => {
  if (method === PaymentsMethods.SELFSERVE_WALLET) {
    return `${COMPANY_NAME} Wallet`;
  }
  return formatEnumValue(method);
};
